<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<form [formGroup]="detalleProductoFormGroup" #productoDetalleForm="ngForm">
    <div class="detalle-producto-panel">
        <div class="detalle-producto-panel__header">
            <div>
                <div class="detalle-producto-panel__title">Agregar productos o servicios</div>
                <div class="detalle-producto-panel__subtitle">Busque y seleccione un resultado: se agregará al detalle con cantidad 1.</div>
            </div>
            <ng-content select="[accionesDescripciones]"></ng-content>
        </div>

        <div class="catalogo-buscador">
            <ng-select class="catalogo-buscador__select" formControlName="catalogo"
                [items]="searchCatalog" bindLabel="nombre" [searchFn]="mostrarResultado"
                [loading]="searchLoading || consultandoProducto" [readonly]="consultandoProducto"
                placeholder="Buscar producto o servicio por código o nombre…"
                aria-label="Buscar producto o servicio por código o nombre"
                (change)="seleccionarResultado($event)" (search)="searchItem($event)"
                (clear)="clearProduct()" notFoundText="Escriba para buscar productos o servicios">
                <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.nombre }}</span>
                    <small class="d-block text-muted">{{ item.tipo }}{{ item.codigo ? ' · ' + item.codigo : '' }}</small>
                </ng-template>
            </ng-select>
            <button type="button" class="btn btn-outline-primary catalogo-buscador__button"
                [disabled]="consultandoProducto" (click)="openProducListModal(listaBuscaProducto)">
                <i class="flaticon-search"></i> Ver productos
            </button>
        </div>

        <div class="detalle-manual-separator" aria-hidden="true">
            <span>o ingrese manualmente</span>
        </div>
    </div>
</form>
<ng-template #list>
	<div class="d-flex flex-column">
		<b class="text-danger" *ngIf="opciones.tipoMoneda == 'USD'">No considerado</b>
		<b>Impuestos</b>
		<span *ngFor="let tax of currentProduct.impuestos"> - {{ tax.nombre }}, {{ tax.valor }} % </span>
	</div>
</ng-template>
<ng-template #listaBuscaProducto let-d="dismiss">
	<div class="selector-modal">
		<div class="modal-header selector-modal__header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">{{ isProductMode ? 'Lista de productos disponibles' : 'Lista de servicios disponibles' }}</div>
				<div class="modal-wizard-desc">Seleccione un {{ isProductMode ? 'producto' : 'servicio' }} para agregarlo al detalle</div>
			</div>
			<button class="btn btn-success float-right" (click)="openCreateProductModal(createProductModal)" *ngIf="isProductMode && permissions.getPermission('30-60-10').asignado">
				<i class="flaticon-add-circular-button"></i>
				Agregar Producto
			</button>
			<button 
				*ngIf="!isProductMode"
				class="btn btn-success float-right"
			(click)="openCreateServiceModal(createServiceModal)">
				<i class="flaticon-add-circular-button"></i>
				Agregar Servicio
			</button>
		</div>
		<div class="selector-modal__tabs">
			<div class="btn-group btn-group-toggle" ngbRadioGroup name="modeToggle">
				<button
					type="button"
					class="btn"
					[ngClass]="isProductMode ? 'btn-primary' : 'btn-light'"
					(click)="setMode(true)">
					Productos
				</button>
				<button
					type="button"
					class="btn"
					[ngClass]="!isProductMode ? 'btn-primary' : 'btn-light'"
					(click)="setMode(false)">
					Servicios
				</button>
			</div>
		</div>
		<div class="selector-modal__filters">
			<app-search-bar class="selector-modal-search" [criterioPrincipal]="currentSearchConfig.criterioPrincipal" [config]="currentSearchConfig" (busqueda)="searchElementsByFilter($event)" [registroActivacion]="true" [productoExento]="true" [insideModal]="true"></app-search-bar>
		</div>
		<div class="modal-body selector-modal__body">
			<div class="selector-modal__toolbar">
				<span class="text-muted">Seleccione un {{ isProductMode ? 'producto' : 'servicio' }} para agregarlo al detalle.</span>
				<label class="selector-modal__page-size">Mostrar
					<select class="form-control form-control-sm" [ngModel]="paginaCatalogo.pageSize" (ngModelChange)="cambiarTamanoCatalogo($event)" [disabled]="loading">
						<option [ngValue]="10">10</option><option [ngValue]="25">25</option><option [ngValue]="50">50</option>
					</select> por página
				</label>
			</div>
			<div class="selector-modal__table table-responsive" [attr.aria-busy]="loading">
				<table class="table mb-0" [attr.aria-label]="isProductMode ? 'Productos disponibles' : 'Servicios disponibles'">
					<thead><tr>
						<th scope="col">Nombre</th>
						<th scope="col" class="text-right">Precio</th>
						<th scope="col" *ngIf="isProductMode">Unidad de medida</th>
						<th scope="col" *ngIf="isProductMode">Código</th>
						<th scope="col">Condición</th>
					</tr></thead>
					<tbody *ngIf="!loading">
						<tr *ngFor="let row of filasCatalogo" class="selector-modal__selectable" (click)="onActivate({ type: 'click', row: row })">
							<td><button type="button" class="selector-modal__select-button" [disabled]="consultandoProducto">{{ row.nombre }}</button></td>
							<td class="text-right text-nowrap">{{ row.precio | currency : '$ ' : 'symbol' : '1.0-0' : 'es' }}</td>
							<td *ngIf="isProductMode">{{ row.unidadMedida || 'Sin unidad' }}</td>
							<td *ngIf="isProductMode">{{ row.codigoBarra || '—' }}</td>
							<td>{{ row.exento ? 'Exento' : 'Afecto' }}</td>
						</tr>
						<tr *ngIf="filasCatalogo.length === 0"><td [attr.colspan]="isProductMode ? 5 : 3" class="selector-modal__empty">No hay {{ isProductMode ? 'productos' : 'servicios' }} para estos filtros.</td></tr>
					</tbody>
					<tbody *ngIf="loading"><tr><td [attr.colspan]="isProductMode ? 5 : 3" class="selector-modal__empty" role="status">Cargando…</td></tr></tbody>
				</table>
			</div>
			<div class="selector-modal__pagination">
				<span class="text-muted" aria-live="polite">{{ paginaCatalogo.totalElements }} {{ isProductMode ? 'productos' : 'servicios' }}</span>
				<ngb-pagination [collectionSize]="paginaCatalogo.totalElements" [page]="paginaCatalogo.pageNumber + 1"
					[pageSize]="paginaCatalogo.pageSize" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
					[disabled]="loading" size="sm" (pageChange)="cambiarPaginaCatalogo($event)" aria-label="Páginas del catálogo">
				</ngb-pagination>
			</div>
		</div>
		<div class="modal-footer selector-modal__footer">
			<button type="button" class="btn btn-light" (click)="d('cerrar')">Cerrar</button>
		</div>
	</div>
</ng-template>
<ng-template #createProductModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Ingreso de Producto</div>
				<div class="modal-wizard-desc">Ingrese los datos para un nuevo producto</div>
			</div>
		</div>
		<div class="modal-body">
			<app-product-entry (sendCloseRequestEmitter)="closeCreateModal()" [detailMode]="false" [useProductAndTaxes]="true" (sendProductRequest)="productWithTaxesRequest($event)"></app-product-entry>
		</div>
	</div>
</ng-template>
<ng-template #createServiceModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Ingreso de Servicio</div>
				<div class="modal-wizard-desc">Ingrese los datos para un nuevo servicio</div>
			</div>
		</div>
		<div class="modal-body">
            <app-servicios-entry (sendCloseRequestEmitter)="closeCreateModal()" [detailMode]="false" (sendServiceRequest)="sendNewServiceOnly($event)" [editMode]="false"></app-servicios-entry>
		</div>
	</div>
</ng-template>
